import { ContainAssessment } from '../../Diary/Assessment/ContainAssessment';
import { ContainCounsellorBio } from './Container/ContainCounsellorBio';
import { ContainJournalEntry } from '../../Diary/JournalEntry/ContainJournalEntry';
import { ContainMoodDetails } from '../../Diary/MoodDetails/ContainMoodDetails';
import { ContainSleepDetails } from '../../Diary/SleepDetails/ContainSleepDetails';
import { FC, ReactElement } from 'react';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';
import { PresentAssessment } from '../../Diary/Assessment/PresentAssessment';
import { PresentCounsellorBio } from './Presentation/PresentCounsellorBio';
import { PresentInstruction } from './Presentation/PresentInstruction';
import { PresentJournalEntry } from '../../Diary/JournalEntry/PresentJournalEntry';
import { PresentMoodDetails } from '../../Diary/MoodDetails/PresentMoodDetails';
import { PresentPhoneNumber } from './Presentation/PresentPhoneNumber';
import { PresentSleepDetails } from '../../Diary/SleepDetails/PresentSleepDetails';
import { SnapshotOut } from 'mobx-state-tree';

export interface QuestionSessionBodyProps   {
  question: SnapshotOut<IQuestionModel>;
  margin: number;
}
export interface QuestionSessionBodyContainerProps {
  question: SnapshotOut<IQuestionModel>;
  children: (presentationState: QuestionSessionBodyState) => ReactElement;
}
export interface QuestionSessionBodyState {
  questionId: string;
  questionKey?: string | null;
  questionType?: string | null;
  questionText?: string | null;
  questionDescription?: string | null;
  questionImage?: string | null;
  loading?: boolean;
  meta?: (readonly {key: string, value: string}[]) | null,
  /** typed payload a Container passes to its Presentation (cast in the pair) */
  data?: Record<string, unknown>;
}
export interface QuestionSessionBodyPresentationProps extends QuestionSessionBodyState {
  margin: number;
}

interface QuestionSessionBodyConfig {
  Container?: FC<QuestionSessionBodyContainerProps>;
  Presentation: FC<QuestionSessionBodyPresentationProps>,
}

/**
 * The challenge frame BRICKS (response-collecting): any admin-built challenge
 * session reuses these by giving its questions the matching key. Display-only
 * frames (memo cards) are staticFrame questions, see QuestionSession. The vocabulary is shared with the
 * API (api/src/app/modules/question/domain/models/frame-kind.ts) — keep both
 * in sync when adding a brick.
 */
export const FRAME_KINDS = ['assessment', 'sleepDetails', 'moodDetails', 'journalEntry'] as const;

export const config: Record<string, QuestionSessionBodyConfig> = {
  /**
   * By question TYPE, not by frame kind: an instruction collects no answer, so
   * it is drawn as a static frame rather than by a presenter of its own.
   */
  instruction: {
    Presentation: PresentInstruction,
  },
  videocallPhoneNumber: {
    Presentation: PresentPhoneNumber,
  },
  phoneNumber: {
    Presentation: PresentPhoneNumber,
  },
  counsellorBio: {
    Container: ContainCounsellorBio,
    Presentation: PresentCounsellorBio,
  },
  assessment: {
    Container: ContainAssessment,
    Presentation: PresentAssessment,
  },
  sleepDetails: {
    Container: ContainSleepDetails,
    Presentation: PresentSleepDetails,
  },
  moodDetails: {
    Container: ContainMoodDetails,
    Presentation: PresentMoodDetails,
  },
  journalEntry: {
    Container: ContainJournalEntry,
    Presentation: PresentJournalEntry,
  },
};
